module.exports = __webpack_public_path__ + "img/Y2402.aad98fe0.jpeg";